/* ════════════════════════════════════════════════════════════════════
   MAPASA DROP — JS del tema (sin dependencias)
   · menú móvil (drawer)
   · ficha: selector de variante (color+talla) → precio/foto/disponible
   · cesta: −/+ y quitar vía /cart/change.js, barra de envío gratis
   ════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var CFG = window.MAPASA || { umbralEnvioGratis: 7400, rutas: { cart: "/cart", cartChange: "/cart/change.js", cartAdd: "/cart/add.js" } };

  function eur(cents) {
    return (cents / 100).toLocaleString("es-ES", { style: "currency", currency: CFG.moneda || "EUR" });
  }

  /* ── Menú móvil ── */
  document.addEventListener("click", function (e) {
    var abre = e.target.closest("[data-mp-abre-menu]");
    var cierra = e.target.closest("[data-mp-cierra-menu]");
    var drawer = document.querySelector("[data-mp-drawer]");
    if (!drawer) return;
    if (abre) { drawer.classList.add("abierto"); document.body.style.overflow = "hidden"; }
    if (cierra) { drawer.classList.remove("abierto"); document.body.style.overflow = ""; }
  });

  /* ── Ficha: variantes + galería carrusel ── */
  var ficha = document.querySelector("[data-mp-ficha]");
  if (ficha) {
    var variantes = JSON.parse(ficha.querySelector("[data-mp-variantes]").textContent);
    var form = ficha.querySelector("form[data-mp-form-producto]");
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = ficha.querySelector("[data-mp-precio]");
    var btn = form.querySelector("[data-mp-anadir]");
    var galTrack = ficha.querySelector("[data-mp-gal-track]");

    function seleccion() {
      var opts = [];
      ficha.querySelectorAll("[data-mp-opcion]").forEach(function (grupo) {
        var marcado = grupo.querySelector("input:checked");
        if (marcado) opts.push(marcado.value);
      });
      return opts;
    }
    function variantePara(opts) {
      return variantes.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function anchoSlide() {
      var s = galTrack && galTrack.querySelector("[data-mp-gal-slide]");
      return s ? s.offsetWidth : (galTrack ? galTrack.offsetWidth : 0);
    }
    function irAFoto(imgId) {
      if (!galTrack || !imgId) return;
      var slide = galTrack.querySelector('[data-img-id="' + imgId + '"]');
      if (slide) galTrack.scrollTo({ left: slide.offsetLeft - galTrack.offsetLeft, behavior: "smooth" });
    }

    function pinta(scroll) {
      var v = variantePara(seleccion());
      ficha.querySelectorAll("[data-mp-valor-opcion]").forEach(function (el) {
        var grupo = el.closest("[data-mp-opcion]");
        var marcado = grupo.querySelector("input:checked");
        if (marcado) el.textContent = marcado.value;
      });
      if (!v) { btn.disabled = true; btn.textContent = "Combinación no disponible"; return; }
      inputId.value = v.id;
      if (precioEl) precioEl.textContent = eur(v.price);
      // TODO PEDIBLE: nunca se bloquea por stock (la escasez es la ventana, no el almacén).
      btn.disabled = false;
      btn.textContent = btn.dataset.textoAnadir || "Añadir a la cesta";
      if (scroll && v.featured_image && v.featured_image.id) irAFoto(v.featured_image.id);
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url.toString());
    }

    ficha.addEventListener("change", function (e) { if (e.target.closest("[data-mp-opcion]")) pinta(true); });
    pinta(false);

    /* Carrusel: flechas + dots + sync al hacer scroll (swipe nativo en móvil) */
    if (galTrack) {
      var dots = ficha.querySelectorAll("[data-mp-gal-dot]");
      ficha.addEventListener("click", function (e) {
        if (e.target.closest("[data-mp-gal-prev]")) galTrack.scrollBy({ left: -anchoSlide(), behavior: "smooth" });
        if (e.target.closest("[data-mp-gal-next]")) galTrack.scrollBy({ left: anchoSlide(), behavior: "smooth" });
        var dot = e.target.closest("[data-mp-gal-dot]");
        if (dot) galTrack.scrollTo({ left: anchoSlide() * parseInt(dot.dataset.i, 10), behavior: "smooth" });
      });
      galTrack.addEventListener("scroll", function () {
        var i = Math.round(galTrack.scrollLeft / (anchoSlide() || 1));
        dots.forEach(function (d, j) { d.classList.toggle("activa", j === i); });
      }, { passive: true });
    }
  }

  /* ── Cesta: cantidad / quitar / barra de envío ── */
  function pintaBarraEnvio(totalCents) {
    var barra = document.querySelector("[data-mp-envio-barra]");
    if (!barra) return;
    var umbral = CFG.umbralEnvioGratis;
    var texto = barra.querySelector("[data-mp-envio-texto]");
    var relleno = barra.querySelector("[data-mp-envio-relleno]");
    var falta = umbral - totalCents;
    if (relleno) relleno.style.width = Math.min(100, (totalCents / umbral) * 100) + "%";
    if (texto) {
      texto.innerHTML = falta > 0
        ? "Te faltan <strong>" + eur(falta) + "</strong> para el envío gratis."
        : "<strong>Envío gratis desbloqueado</strong> — premio.";
    }
  }

  function cambiaLinea(key, qty) {
    return fetch(CFG.rutas.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Re-render simple y robusto: recargamos la página de cesta con el estado real.
        if (document.querySelector("[data-mp-cesta-pagina]")) window.location.reload();
        else actualizaBadge(cart.item_count);
        return cart;
      });
  }

  function actualizaBadge(count) {
    document.querySelectorAll("[data-mp-cesta-badge]").forEach(function (b) {
      b.textContent = count;
      b.setAttribute("data-count", count);
    });
  }

  document.addEventListener("click", function (e) {
    var mas = e.target.closest("[data-mp-qty-mas]");
    var menos = e.target.closest("[data-mp-qty-menos]");
    var quitar = e.target.closest("[data-mp-quitar]");
    var linea = e.target.closest("[data-mp-linea]");
    if (!linea) return;
    var key = linea.dataset.key;
    var qty = parseInt(linea.dataset.qty, 10);
    if (mas) cambiaLinea(key, qty + 1);
    if (menos && qty > 1) cambiaLinea(key, qty - 1); // mínimo 1; quitar es explícito
    if (quitar) cambiaLinea(key, 0);
  });

  var cestaPagina = document.querySelector("[data-mp-cesta-pagina]");
  if (cestaPagina) pintaBarraEnvio(parseInt(cestaPagina.dataset.total, 10));
})();

/* ════════════════════════════════════════════════════
   V2 — QUICK-VIEW + PACK MINI-ME (réplica del motor web)
   ════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var CFG = window.MAPASA || { rutas: { cart: "/cart", cartAdd: "/cart/add.js" } };
  function eur(cents) {
    return (cents / 100).toLocaleString("es-ES", { style: "currency", currency: CFG.moneda || "EUR" });
  }
  function actualizaBadge(count) {
    document.querySelectorAll("[data-mp-cesta-badge]").forEach(function (b) {
      b.textContent = count;
      b.setAttribute("data-count", count);
    });
  }
  function toast(html) {
    var t = document.querySelector("[data-mp-toast]");
    if (!t) return;
    t.querySelector("span").innerHTML = html;
    t.classList.add("visible");
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove("visible"); }, 4500);
  }
  function anadir(items) {
    return fetch(CFG.rutas.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || "No se pudo añadir"); });
      return fetch("/cart.js").then(function (rc) { return rc.json(); }).then(function (cart) {
        actualizaBadge(cart.item_count);
        if (window.fbq) window.fbq("track", "AddToCart");
        document.dispatchEvent(new CustomEvent("mp:cart-added", { detail: cart }));
        return cart;
      });
    });
  }

  /* ── QUICK-VIEW: botón «vistazo» en las cards de colección ── */
  var qv = document.querySelector("[data-mp-qv]");
  function cierraQv() { if (qv) { qv.classList.remove("abierto"); document.body.style.overflow = ""; } }

  document.addEventListener("click", function (e) {
    var boton = e.target.closest("[data-mp-vistazo]");
    if (boton && qv) {
      e.preventDefault();
      abreQv(boton.dataset.handle);
      return;
    }
    if (e.target.closest("[data-mp-qv-cierra]")) cierraQv();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") cierraQv(); });

  function abreQv(handle) {
    fetch("/products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var cuerpo = qv.querySelector("[data-mp-qv-cuerpo]");
        var selects = p.options
          .map(function (o, i) {
            var valores = o.values
              .map(function (v) { return '<option value="' + v.replace(/"/g, "&quot;") + '">' + v + "</option>"; })
              .join("");
            return (
              '<div class="mp-qv__opcion"><p class="mp-opcion__label">' + o.name + "</p>" +
              '<select data-mp-qv-opt="' + i + '">' + valores + "</select></div>"
            );
          })
          .join("");
        cuerpo.innerHTML =
          '<div class="mp-qv__foto">' +
          (p.featured_image ? '<img src="' + p.featured_image + '" alt="">' : '<div class="mp-foto-placeholder">foto</div>') +
          "</div>" +
          "<div>" +
          '<h3 class="mp-qv__titulo">' + p.title + "</h3>" +
          '<p class="mp-qv__precio" data-mp-qv-precio>' + eur(p.price) + "</p>" +
          selects +
          '<button type="button" class="mp-btn mp-btn--primario mp-btn--block" style="margin-top:20px;" data-mp-qv-anadir>Añadir a la cesta</button>' +
          '<p class="mp-qv__ok mp-oculto" data-mp-qv-ok></p>' +
          '<a class="mp-qv__enlace" href="/products/' + p.handle + '">Ver la ficha completa →</a>' +
          "</div>";
        qv._producto = p;
        pintaQv();
        qv.classList.add("abierto");
        document.body.style.overflow = "hidden";
      });
  }

  function seleccionQv() {
    return Array.prototype.map.call(qv.querySelectorAll("[data-mp-qv-opt]"), function (s) { return s.value; });
  }
  function varianteQv() {
    var opts = seleccionQv();
    return (qv._producto.variants || []).find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }
  function pintaQv() {
    var v = varianteQv();
    var btn = qv.querySelector("[data-mp-qv-anadir]");
    var precio = qv.querySelector("[data-mp-qv-precio]");
    if (!btn) return;
    if (!v) { btn.disabled = true; btn.textContent = "Combinación no disponible"; return; }
    btn.disabled = !v.available;
    btn.textContent = v.available ? "Añadir a la cesta" : "Agotada en esta combinación";
    if (precio) precio.textContent = eur(v.price);
    if (v.featured_image && v.featured_image.src) {
      var img = qv.querySelector(".mp-qv__foto img");
      if (img) img.src = v.featured_image.src;
    }
  }
  if (qv) {
    qv.addEventListener("change", function (e) { if (e.target.closest("[data-mp-qv-opt]")) pintaQv(); });
    qv.addEventListener("click", function (e) {
      if (!e.target.closest("[data-mp-qv-anadir]")) return;
      var v = varianteQv();
      if (!v) return;
      anadir([{ id: v.id, quantity: 1 }])
        .then(function () {
          var ok = qv.querySelector("[data-mp-qv-ok]");
          if (ok) { ok.classList.remove("mp-oculto"); ok.textContent = "En la cesta ✓"; }
          toast('Añadida. <a href="' + CFG.rutas.cart + '">Ir a la cesta →</a>');
          setTimeout(cierraQv, 900);
        })
        .catch(function (err) { toast(err.message); });
    });
  }

  /* ── PACK MINI-ME: talla por pieza, un botón, un solo add ── */
  var pack = document.querySelector("[data-mp-pack]");
  if (pack) {
    function estadoPack() {
      var piezas = [];
      pack.querySelectorAll("[data-mp-pack-pieza]").forEach(function (p) {
        var dentro = p.querySelector("[data-mp-pack-check]").checked;
        p.classList.toggle("fuera", !dentro);
        var sel = p.querySelector("[data-mp-pack-variante]");
        var opcion = sel.options[sel.selectedIndex];
        piezas.push({
          dentro: dentro,
          id: parseInt(sel.value, 10),
          precio: parseInt(opcion.dataset.precio, 10),
          disponible: opcion.dataset.disponible === "true",
        });
      });
      return piezas;
    }
    function pintaPack() {
      var piezas = estadoPack().filter(function (p) { return p.dentro; });
      var total = piezas.reduce(function (s, p) { return s + p.precio; }, 0);
      var totalEl = pack.querySelector("[data-mp-pack-total]");
      if (totalEl) totalEl.textContent = eur(total);
      var envio = pack.querySelector("[data-mp-pack-envio]");
      if (envio) envio.classList.toggle("mp-oculto", total < (CFG.umbralEnvioGratis || 7400));
      var btn = pack.querySelector("[data-mp-pack-anadir]");
      var sinStock = piezas.some(function (p) { return !p.disponible; });
      btn.disabled = piezas.length === 0 || sinStock;
      btn.textContent = sinStock ? "Alguna pieza está agotada en esa talla" : "Añadir el look completo";
    }
    pack.addEventListener("change", pintaPack);
    pack.addEventListener("click", function (e) {
      if (!e.target.closest("[data-mp-pack-anadir]")) return;
      var items = estadoPack()
        .filter(function (p) { return p.dentro && p.disponible; })
        .map(function (p) { return { id: p.id, quantity: 1 }; });
      if (!items.length) return;
      anadir(items)
        .then(function () { toast('Look completo en la cesta. <a href="' + CFG.rutas.cart + '">Ir a la cesta →</a>'); })
        .catch(function (err) { toast(err.message); });
    });
    pintaPack();
  }
})();

/* ════════════════════════════════════════════════════
   CESTA-CAJÓN (drawer AJAX) — réplica de CestaDrawer.tsx
   Abre sin salir de la página (icono cesta + al añadir).
   ════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var CFG = window.MAPASA || {};
  var UMBRAL = CFG.umbralEnvioGratis || 7400;
  var RUTAS = CFG.rutas || {};
  var CART_CHANGE = RUTAS.cartChange || "/cart/change.js";
  var CART_ADD = RUTAS.cartAdd || "/cart/add.js";
  var COLECCIONES = RUTAS.collections || "/collections";
  function eur(c) { return (c / 100).toLocaleString("es-ES", { style: "currency", currency: CFG.moneda || "EUR" }); }

  var drawer = document.querySelector("[data-mp-cesta-drawer]");
  if (!drawer) return;
  var cuerpo = drawer.querySelector("[data-mp-cd-cuerpo]");
  var pie = drawer.querySelector("[data-mp-cd-pie]");
  var lastCart = null;
  var deshacer = null;

  function badge(n) {
    document.querySelectorAll("[data-mp-cesta-badge]").forEach(function (b) { b.textContent = n; b.setAttribute("data-count", n); });
  }
  function abrir() { drawer.classList.add("abierto"); drawer.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; }
  function cerrar() { drawer.classList.remove("abierto"); drawer.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; }
  function getCart() { return fetch("/cart.js").then(function (r) { return r.json(); }); }

  function propsHtml(props) {
    if (!props) return "";
    return Object.keys(props).filter(function (k) { return props[k] && k.charAt(0) !== "_"; })
      .map(function (k) { return '<p class="mp-linea__props">' + k + ": " + props[k] + "</p>"; }).join("");
  }

  function render(cart) {
    lastCart = cart;
    badge(cart.item_count);
    if (cart.item_count === 0) {
      cuerpo.innerHTML = '<div class="mp-cd__vacia"><p class="mp-display" style="font-size:20px;margin:0;">Aún nada dentro.</p>' +
        '<p style="color:var(--mp-tinta-suave);margin:8px 0 0;">La ventana no espera — lo que no se pide, no se fabrica.</p>' +
        '<a href="' + COLECCIONES + '" class="mp-btn mp-btn--primario" data-mp-cesta-cierra style="margin-top:16px;">Ver los mundos →</a></div>';
      pie.hidden = true;
      return;
    }
    pie.hidden = false;
    var lineas = cart.items.map(function (it) {
      var sub = (it.variant_title && it.variant_title !== "Default Title") ? '<p class="mp-linea__sub">' + it.variant_title + "</p>" : "";
      var img = it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : "";
      return '<div class="mp-linea" data-key="' + it.key + '" data-qty="' + it.quantity + '">' +
        '<a href="' + it.url + '" class="mp-linea__foto">' + img + "</a>" +
        '<div><p class="mp-linea__nombre"><a href="' + it.url + '">' + it.product_title + "</a></p>" + sub + propsHtml(it.properties) +
          '<div class="mp-qty"><button type="button" data-mp-qty-menos aria-label="una menos">−</button><span>' + it.quantity + '</span><button type="button" data-mp-qty-mas aria-label="una más">+</button></div></div>' +
        '<div><p class="mp-linea__precio">' + eur(it.final_line_price) + '</p><button type="button" class="mp-linea__quitar" data-mp-quitar>quitar</button></div>' +
      "</div>";
    }).join("");
    cuerpo.innerHTML = '<div data-mp-cd-lineas>' + lineas + '</div><div data-mp-cd-upsell></div>';
    barra(cart.total_price);
    var totalEl = drawer.querySelector("[data-mp-cd-total]");
    if (totalEl) totalEl.textContent = eur(cart.total_price);
    upsell(cart);
  }

  function barra(total) {
    var texto = drawer.querySelector("[data-mp-envio-texto]");
    var relleno = drawer.querySelector("[data-mp-envio-relleno]");
    var falta = UMBRAL - total;
    if (relleno) relleno.style.width = Math.min(100, (total / UMBRAL) * 100) + "%";
    if (texto) texto.innerHTML = falta > 0
      ? "Te faltan <strong>" + eur(falta) + "</strong> para el envío gratis."
      : "<strong>Envío gratis</strong> desbloqueado — premio. 🎉";
  }

  function upsell(cart) {
    var cont = drawer.querySelector("[data-mp-cd-upsell]");
    if (!cont || !cart.items.length) { if (cont) cont.innerHTML = ""; return; }
    var enCesta = cart.items.map(function (i) { return i.product_id; });
    var pid = cart.items[0].product_id;
    fetch("/recommendations/products.json?product_id=" + pid + "&intent=complementary&limit=6")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.products || []).filter(function (p) { return enCesta.indexOf(p.id) === -1; }).slice(0, 3);
        if (!prods.length) { cont.innerHTML = ""; return; }
        cont.innerHTML = '<div class="mp-cd-up"><p class="mp-cd-up__t">Remata el look</p>' +
          prods.map(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
            if (!v) return "";
            var foto = p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy">' : "";
            return '<div class="mp-cd-up__it">' + foto +
              '<div><p class="mp-cd-up__n">' + p.title + '</p><p class="mp-cd-up__p">' + eur(p.price) + "</p></div>" +
              '<button type="button" class="mp-cd-up__add" data-mp-add-var="' + v.id + '"' + (v.available ? "" : " disabled") + ' aria-label="añadir ' + p.title + '">+</button></div>';
          }).join("") + "</div>";
      })
      .catch(function () { cont.innerHTML = ""; });
  }

  function cambia(key, qty) {
    return fetch(CART_CHANGE, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (cart) { render(cart); return cart; });
  }
  function add(items, abrirTras) {
    return fetch(CART_ADD, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || "No se pudo añadir"); }); return getCart(); })
      .then(function (cart) { render(cart); if (window.fbq) window.fbq("track", "AddToCart"); if (abrirTras) abrir(); return cart; });
  }

  function undoBar(nombre) {
    var lineasCont = drawer.querySelector("[data-mp-cd-lineas]");
    if (!lineasCont || !deshacer) return;
    var bar = document.createElement("div");
    bar.className = "mp-cd-undo";
    bar.innerHTML = "Quitado «" + nombre + "». <button type=\"button\" data-mp-undo>Deshacer</button>";
    lineasCont.prepend(bar);
    deshacer.timer = setTimeout(function () { bar.remove(); deshacer = null; }, 6000);
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-mp-abre-cesta]")) { e.preventDefault(); getCart().then(function (c) { render(c); abrir(); }); return; }
    if (e.target.closest("[data-mp-cesta-cierra]")) { cerrar(); return; }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") cerrar(); });

  drawer.addEventListener("click", function (e) {
    var addv = e.target.closest("[data-mp-add-var]");
    if (addv) { if (!addv.disabled) add([{ id: parseInt(addv.dataset.addVar, 10), quantity: 1 }]); return; }
    var undo = e.target.closest("[data-mp-undo]");
    if (undo) { if (deshacer) { clearTimeout(deshacer.timer); add(deshacer.items); deshacer = null; } return; }
    var linea = e.target.closest("[data-key]");
    if (!linea) return;
    var key = linea.dataset.key, qty = parseInt(linea.dataset.qty, 10);
    if (e.target.closest("[data-mp-qty-mas]")) { cambia(key, qty + 1); return; }
    if (e.target.closest("[data-mp-qty-menos]")) { if (qty > 1) cambia(key, qty - 1); return; }
    if (e.target.closest("[data-mp-quitar]")) {
      var it = lastCart && lastCart.items.filter(function (i) { return i.key === key; })[0];
      cambia(key, 0).then(function () {
        if (it) { deshacer = { items: [{ id: it.variant_id, quantity: it.quantity, properties: it.properties }], timer: null }; undoBar(it.product_title); }
      });
      return;
    }
  });

  // La ficha añade por AJAX y abre el cajón (en vez de navegar a /cart)
  document.addEventListener("submit", function (e) {
    var f = e.target.closest("[data-mp-form-producto]");
    if (!f) return;
    e.preventDefault();
    var fd = new FormData(f);
    var item = { id: fd.get("id"), quantity: parseInt(fd.get("quantity") || "1", 10) };
    fd.forEach(function (val, key) {
      if (key.indexOf("properties[") === 0 && val) { item.properties = item.properties || {}; item.properties[key.slice(11, -1)] = val; }
    });
    add([item], true).catch(function (err) {
      var t = document.querySelector("[data-mp-toast]");
      if (t) { t.querySelector("span").textContent = err.message; t.classList.add("visible"); }
    });
  });

  // Pack / quick-view disparan mp:cart-added → abrir el cajón
  document.addEventListener("mp:cart-added", function (e) { if (e.detail) render(e.detail); abrir(); });
})();

/* ════════════════════════════════════════════════════
   FICHA — "a juego con esto" (recomendados) + guía de tallas
   ════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var CFG = window.MAPASA || {};
  function eur(c) { return (c / 100).toLocaleString("es-ES", { style: "currency", currency: CFG.moneda || "EUR" }); }

  /* Guía de tallas (modal) + preferencias de cookies (API de Shopify) */
  var guia = document.querySelector("[data-mp-guia]");
  document.addEventListener("click", function (e) {
    if (guia && e.target.closest("[data-mp-guia-abre]")) { guia.classList.add("abierto"); document.body.style.overflow = "hidden"; }
    if (guia && e.target.closest("[data-mp-guia-cierra]")) { guia.classList.remove("abierto"); document.body.style.overflow = ""; }
    if (e.target.closest("[data-mp-cookie-prefs]")) {
      e.preventDefault();
      if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
      else if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.showPreferences) window.Shopify.customerPrivacy.showPreferences();
    }
  });
  document.addEventListener("keydown", function (e) { if (guia && e.key === "Escape") { guia.classList.remove("abierto"); document.body.style.overflow = ""; } });

  /* A juego con esto (recomendaciones nativas de Shopify por afinidad) */
  var aj = document.querySelector("[data-mp-ajuego]");
  if (aj) {
    fetch("/recommendations/products.json?product_id=" + aj.dataset.productId + "&intent=related&limit=4")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.products || []).slice(0, 4);
        if (!prods.length) return;
        var grid = aj.querySelector("[data-mp-ajuego-grid]");
        grid.innerHTML = prods.map(function (p) {
          var foto = p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy">' : "";
          return '<div class="mp-aj-card"><a href="/products/' + p.handle + '" class="mp-aj-card__foto">' + foto + "</a>" +
            '<p class="mp-aj-card__n"><a href="/products/' + p.handle + '">' + p.title + "</a></p>" +
            '<p class="mp-aj-card__p">' + eur(p.price) + "</p>" +
            '<button type="button" class="mp-aj-card__qv" data-mp-vistazo data-handle="' + p.handle + '">vistazo +</button></div>';
        }).join("");
        aj.hidden = false;
      })
      .catch(function () {});
  }
})();
